import cookies from 'js-cookie';


// 设计稿尺寸转PX
let WINDOW_WIDTH = 0;
export const designSize2Px = (elementSize: number, designSize = 828) => {
    if (!WINDOW_WIDTH){ WINDOW_WIDTH = window.innerWidth;}
    return (elementSize / designSize) * WINDOW_WIDTH;
};

export function getRequest() {
    let url = decodeURIComponent(window.location.search);
    const theRequest: Record<string, string> = {};
    if (url.indexOf('?') !== -1) {
        url = url.substr(1);
    }
    if (url) {
        const strs = url.split('&');
        for (let i = 0; i < strs.length; i++) {
            const srtArry = strs[i].split('=');
            const y = srtArry.shift() as string;
            theRequest[y] = decodeURIComponent(srtArry.join('='));
        }
    }
    return theRequest;
}


export function getQuery (param: string){
    if (URLSearchParams){
        const urlSearchParams = new URLSearchParams(window.location.search);
        return urlSearchParams.get(param);
    }

    const urlObject = getRequest();
    return urlObject[param];
};

// 国家列表
export enum COUNTRY_LIST {
  // PRO
  BRA = 'br', // 巴西
  COL = 'col', // 哥伦比亚
  MEX = 'mex', // 墨西哥
  ARG = 'arg', // 阿根廷
  PER = 'per', // 秘鲁
  CHL = 'chl', // 智利
  ECU = 'ecu', // 厄瓜多尔
  DOM = 'dom', // 多米尼加
  // SV
  IDN = 'in', // 印尼
  PAK = 'pak', // 巴基斯坦
  // ME
  TUR = 'tur', // 土耳其
  EGY = 'egy', // 埃及
  IRQ = 'irq', // 伊拉克
  DZA = 'dza', // 阿尔及利亚
  SAU = 'sau', // 沙特阿拉伯王国
  SPA = 'spa', // 西班牙
}


// 货币分隔符
type separator = {
  // 千分位
  thousands: string;
  // 小数点
  decimalPoint: string;
}

const countryCurrencySeparator: Record<COUNTRY_LIST, separator> = {
    [COUNTRY_LIST.BRA]: {
        thousands: '.',
        decimalPoint: ',',
    },
    [COUNTRY_LIST.COL]: {
        thousands: '.',
        decimalPoint: ',',
    },
    [COUNTRY_LIST.MEX]: {
        thousands: ',',
        decimalPoint: '.',
    },
    [COUNTRY_LIST.ARG]: {
        thousands: '.',
        decimalPoint: ',',
    },
    [COUNTRY_LIST.PER]: {
        thousands: ',',
        decimalPoint: '.',
    },
    [COUNTRY_LIST.CHL]: {
        thousands: '.',
        decimalPoint: ',',
    },
    [COUNTRY_LIST.ECU]: {
        thousands: '.',
        decimalPoint: ',',
    },
    [COUNTRY_LIST.DOM]: {
        thousands: ',',
        decimalPoint: '.',
    },
    [COUNTRY_LIST.TUR]: {
        thousands: '.',
        decimalPoint: ',',
    },
    [COUNTRY_LIST.IDN]: {
        thousands: '.',
        decimalPoint: ',',
    },
    [COUNTRY_LIST.PAK]: {
        thousands: ',',
        decimalPoint: '.',
    },
    [COUNTRY_LIST.EGY]: {
        thousands: ',',
        decimalPoint: '.',
    },
    [COUNTRY_LIST.IRQ]: {
        thousands: ',',
        decimalPoint: '.',
    },
    [COUNTRY_LIST.DZA]: {
        thousands: ',',
        decimalPoint: '.',
    },
    [COUNTRY_LIST.SAU]: {
        thousands: ',',
        decimalPoint: '.',
    },
    [COUNTRY_LIST.SPA]: {
        thousands: ',',
        decimalPoint: '.',
    },
};

// 获取国家
const getCountry = (): COUNTRY_LIST => {
    // 优先使用客户端注入的Cookie
    let countryInfo = (cookies.get('bucket'));

    if (!countryInfo){
        // 未注入使用query参数
        countryInfo = (getQuery('countryInfo') || '');
    }

    countryInfo = countryInfo.toLowerCase();

    // todo 猜测历史原因，是因为融合前巴西的kconf设计的有问题，导致需要兼容
    // 影响：端外的countryInfo字段被污染
    return countryInfo === 'bra'
        ? COUNTRY_LIST.BRA
        : (countryInfo as COUNTRY_LIST);
};

// 当前国家
export const webCountry = getCountry();

export const currencySeparator: separator = countryCurrencySeparator[webCountry] || {
    thousands: '.',
    decimalPoint: ',',
};

export const toLocaleString = (value: number) => {
    const { thousands, decimalPoint } = currencySeparator;

    const splitNumber = value.toString().split('.');
    let integer = splitNumber[0];
    const decimal = splitNumber[1] || '';

    let result = '';

    while (integer.length > 3) {
        result = thousands + integer.slice(-3) + result;
        integer = integer.slice(0, integer.length - 3);
    }

    if (integer) {
        result = integer + result;
    }

    if (decimal === '') {
        return result;
    }

    return result + decimalPoint + decimal;
};

const timezoneMap: Record<COUNTRY_LIST, number> = {
    [COUNTRY_LIST.BRA]: 3,
    [COUNTRY_LIST.COL]: 5,
    [COUNTRY_LIST.MEX]: 5,
    [COUNTRY_LIST.ARG]: 3,
    [COUNTRY_LIST.PER]: 5,
    [COUNTRY_LIST.CHL]: 4,
    [COUNTRY_LIST.ECU]: 5,
    [COUNTRY_LIST.DOM]: 4,
    [COUNTRY_LIST.TUR]: -3, // 东三
    [COUNTRY_LIST.IDN]: -7, // 印尼
    [COUNTRY_LIST.PAK]: -5, // 巴基斯坦
    [COUNTRY_LIST.EGY]: -2, // 埃及
    [COUNTRY_LIST.IRQ]: -3, // 伊拉克
    [COUNTRY_LIST.DZA]: -1, // 阿尔及利亚
    [COUNTRY_LIST.SAU]: -3, // 沙特阿拉伯王国
} as any;

const timeFormatTypeMap: Record<COUNTRY_LIST, string> = {
    [COUNTRY_LIST.BRA]: 'YYYY-MM-DD HH:mm',
    [COUNTRY_LIST.COL]: 'DD-MM-YYYY HH:mm',
    [COUNTRY_LIST.MEX]: 'DD-MM-YYYY HH:mm',
    [COUNTRY_LIST.ARG]: 'DD-MM-YYYY HH:mm',
    [COUNTRY_LIST.PER]: 'DD-MM-YYYY HH:mm',
    [COUNTRY_LIST.CHL]: 'DD-MM-YYYY HH:mm',
    [COUNTRY_LIST.ECU]: 'DD-MM-YYYY HH:mm',
    [COUNTRY_LIST.DOM]: 'DD-MM-YYYY HH:mm',
    [COUNTRY_LIST.TUR]: 'DD-MM-YYYY HH:mm',
    [COUNTRY_LIST.IDN]: 'DD-MM-YYYY HH:mm', // 印尼
    [COUNTRY_LIST.PAK]: 'YYYY-MM-DD HH:mm', // 巴基斯坦
    [COUNTRY_LIST.EGY]: 'YYYY-MM-DD HH:mm', // 埃及
    [COUNTRY_LIST.IRQ]: 'YYYY-MM-DD HH:mm', // 伊拉克
    [COUNTRY_LIST.DZA]: 'YYYY-MM-DD HH:mm', // 阿尔及利亚
    [COUNTRY_LIST.SAU]: 'DD-MM-YYYY HH:mm', // 沙特阿拉伯王国
} as any;


export const timeFormatType = timeFormatTypeMap[webCountry];

export const timezone = timezoneMap[webCountry];
